import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DA544",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M11.999 4.696 21.912 12l-9.913 7.305L2.086 12z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12.002 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M9.914 11.74a7 7 0 0 0-2.086.315 4.173 4.173 0 0 0 7.59 2.34 7.03 7.03 0 0 0-5.504-2.655M16.096 12.8q.076-.39.078-.8a4.174 4.174 0 0 0-8.01-1.647 8.6 8.6 0 0 1 7.932 2.447"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }